import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiGetDirectDebt, apiGetDirectDebtDiscovery } from "../../../../services/modules/direct-debt";

//Patch/Get Direct Debt
export const getDirectDebt = createAsyncThunk(
  "directDebt/getDirectDebt",
  async (externalId: string, thunkAPI) => {
    try {
      const data = await apiGetDirectDebt({externalId});
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getDirectDebtDiscovery = createAsyncThunk(
  "directDebt/getDirectDebtDiscovery",
  async (loanId: string, thunkAPI) => {
    try {
      const data = await apiGetDirectDebtDiscovery({loanId});
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
